import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ICcyPairPromiseLookupService } from "../ICcyPairPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { CcyPairLookupService } from "./CcyPairLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CcyPairReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.CurrencyPairImpl>
  implements ICcyPairPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.CurrencyPairImpl,
      "CurrencyPairImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new CcyPairLookupService(),
    );
  }

  getCcyPair(base: string, nonBase: string): Promise<CubiqTS.CurrencyPairImpl> {
    let request = new UiArguments("getCcyPair");
    let arg1 = new FnArg(base, PRIMITIVE);
    let arg2 = new FnArg(nonBase, PRIMITIVE);
    request.args = [arg1, arg2];
    return this.broker.runOnService(request, this.VALUE);
  }

  getVehicleCurrencies(base: string, nonBase: string): Promise<Array<any>> {
    let request = new UiArguments("getVehicleCurrencies");
    let arg1 = new FnArg(base, PRIMITIVE);
    let arg2 = new FnArg(nonBase, PRIMITIVE);
    request.args = [arg1, arg2];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
